<div class="dialog-header">
  <span class="dialog-title">Add Group</span>
  <span class="material-symbols-outlined dialog-close close-button" (click)="dialogRef.close()" type="button">close</span>
</div>

<div class="dialog-content">
  <div class="field">
    <label class="field__label">Group Name</label>
    <input class="field__input" type="text" [(ngModel)]="groupName" #nameCtrl="ngModel" required
      placeholder="Group Name">
  </div>
  <small class="dialog-hint">Groups are created using default markup values. To adjust these values, please edit the
    group after creation.</small>
</div>

<div class="dialog-actions">
  <button class="cancel-button" mat-dialog-close type="button">Cancel</button>
  <button class="save-button" type="button" (click)="save()">Submit</button>
</div>